import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';

import { selectFkoDegraded, setFkoDegraded } from '@/store/system';
import { useLevvelTranslation } from '@/hooks/useLevvelTranslation';

// FKA org delimitation R3 — raised when this login's FKO validation degraded.
//
// The login SUCCEEDED and the app is fully usable, so this is a dismissible
// notice, not an error screen and not a blocking gate. The backend froze the
// user's existing organisation bindings rather than deleting them (nothing is
// ever removed on an error path), which is precisely what makes the set
// possibly STALE — that is the one fact the copy has to carry.
//
// Its own copy on purpose: the generic 5xx interceptor and the generic failure
// toast both say a request failed, which is not what happened here and would
// send the user looking for a broken page instead of telling them their
// organisation list may be out of date.
//
// Mounted once at the app root (index.tsx), NOT inside AuthedContainer — that
// one wraps each route and would give the dialog several concurrent instances.
const FkoStatusModal = () => {
  const { lt } = useLevvelTranslation();
  const dispatch = useDispatch();
  const degraded = useSelector(selectFkoDegraded);

  if (!degraded) {
    return null;
  }

  const dismiss = () => dispatch(setFkoDegraded(false));

  return (
    <Modal show onHide={dismiss} centered>
      <Modal.Header className="d-flex justify-content-center mt-4">
        <Modal.Title>
          <h3 className="text-bold">{lt('cdb_message_status_warning_text')}</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">{lt('cdb_fko_unavailable_message')}</div>
        <Modal.Footer className="d-flex justify-content-center border-0">
          <Button
            className="title-semiBold"
            variant="primary"
            onClick={dismiss}>
            {lt('cdb_mobile_modal_close_text')}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default FkoStatusModal;
